export const WEBHOOK_EVENTS = [
  'sale.invoice.create',
  'sale.invoice.update',
  'sale.invoice.resubmit',
  'sale.credit_note.create',
  'sale.credit_note.update',
  'sale.credit_note.resubmit',
  'purchase.invoice.create',
  'purchase.invoice.update',
  'purchase.invoice.resubmit',
  'purchase.credit_note.create',
  'purchase.credit_note.update',
  'purchase.credit_note.resubmit',
];
